import { useNavigate, useSearch } from "@tanstack/react-router";
import { useCallback } from "react";

/**
 * 個人資格一覧のURL検索パラメータを管理するカスタムフック
 */
export function useCertificationsSearch() {
  const search = useSearch({ strict: false });
  const navigate = useNavigate();

  /**
   * フリーテキスト検索ワードを変更する
   */
  const changeFreeText = useCallback(
    (freeText: string) => {
      navigate({
        to: ".",
        search: { ...search, freeText, page: 1 },
      });
    },
    [navigate, search],
  );

  return {
    search,
    changeFreeText,
  };
}
